import { toCamel } from './../Util/SnakeCamelUtil';
import { DiagnoseDAO } from './../DAO/DiagnoseDAO';
import { BaseService } from './BaseService';

/**
 * UserService
 *
 * ログイン認証関係のロジックサービス
 * DAOで取得したデータを操作等行い、View側に渡す。
 */
export class DiagnoseService extends BaseService {


	// 検査結果のリストを取得
	public async getDiagnoseList() {

		const dao = new DiagnoseDAO(this as BaseService);
		const ret = await dao.getDiagnoseList();
		const dist = this.obj2Array(toCamel(ret));

		return dist;

	}


	// 検査結果の詳細取得
	public async getDiagnoseDetail(fileId: any) {

		const dao = new DiagnoseDAO(this as BaseService);
		const ret = await dao.getDiagnoseDetail(fileId);

		return ret;

	}


}

